<template>
  <or-layout>
    <a-row :gutter="[16, 16]" type="flex" justify="space-between">
      <a-col :span="5">
        <a-button type="primary" @click="tableAdd">创建</a-button>
      </a-col>
      <a-col>
        <a-form layout="inline">
          <a-form-item>
            <a-select v-model="searchFrom.grade_id" placeholder="年级" style="width: 120px;">
              <a-select-option value="">全部</a-select-option>
              <a-select-option v-for="(item) in gradeList" :key="item.id" :value="item.id">{{ item.name }}</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item>
            <a-select v-model="searchFrom.subject" placeholder="学科" allow-clear>
              <a-select-option :value="1">数学</a-select-option>
              <a-select-option :value="2">英语</a-select-option>
              <a-select-option :value="3">语文</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item>
            <a-select v-model="searchFrom.semester_id" placeholder="学期" style="width: 120px;">
              <a-select-option value="">全部</a-select-option>
              <a-select-option v-for="(item) in semesterList" :key="item.id"
                :value="item.id">{{ item.name }}</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item>
            <a-input placeholder="课程名" v-model="searchFrom.keyword" @keyup.enter="tableSearch"></a-input>
          </a-form-item>
          <a-form-item>
            <a-button type="primary" htmlType="submit" icon="search" @click="tableSearch"></a-button>
          </a-form-item>
        </a-form>
      </a-col>
    </a-row>
    <a-divider></a-divider>
    <div>
      <a-table :dataSource="data" :rowKey="item => item.id" :pagination="pageinfo" :loading="loading"
        @change="onPaginationChange" bordered>
        <a-table-column key="name" title="课程名" data-index="name" />
        <a-table-column key="status" title="状态">
          <template slot-scope="item">
            <span v-if="item.status == 1">可用</span>
            <span v-if="item.status == 0">已禁用</span>
          </template>
        </a-table-column>
        <a-table-column key="active" title="操作">
          <template slot-scope="item">
            <router-link :to="{ path: '/basicchapter', query: { course_id: item.id } }">查看章节</router-link>
            <a-button v-if="item.status == 0" @click="changeStatus({ id: item.id, status: 1, pid: item.pid })" class="active_btn"
              size="small" type="link">启用
            </a-button>
            <a-button v-if="item.status == 1" @click="changeStatus({ id: item.id, status: 0, pid: item.pid })" class="active_btn"
              size="small" type="link">禁用
            </a-button>
            <a-button v-if="item.status == 1" @click="tableEdit(item)" class="active_btn" size="small" type="link">编辑
            </a-button>
          </template>
        </a-table-column>
      </a-table>
    </div>
    <a-modal :visible="visible" title="课程信息" @ok="modalSave" :destroyOnClose="true" @cancel="modalCancel">
      <a-form>
        <a-input type="hidden" v-model="form.id" />
        <a-form-item>
          <a-input v-model="form.name" placeholder="课程名" />
        </a-form-item>
        <a-form-item>
          <a-select v-model="form.semester_id" placeholder="学期" allow-clear>
            <a-select-option v-for="(item) in semesterList" :key="item.id"
              :value="item.id">{{ item.name }}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item>
          <a-select v-model="form.grade_id" placeholder="年级" allow-clear>
            <a-select-option v-for="(item) in gradeList" :key="item.id" :value="item.id">{{ item.name }}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item>
          <a-select v-model="form.series" placeholder="体系" allow-clear>
            <a-select-option v-for="(item) in myseries" :key="item.id" :checked="item.id == form.series ? true : false"
              :value="item.id">{{ item.name }}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item>
          <a-select v-model="form.subject" placeholder="学科" allow-clear>
            <a-select-option :value="1">数学</a-select-option>
            <a-select-option :value="2">英语</a-select-option>
            <a-select-option :value="3">语文</a-select-option>
            <a-select-option :value="4">化学</a-select-option>
            <a-select-option :value="5">物理</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item class="pptAddress">
          <a-input v-model="form.ppt_zip_path" placeholder="ppt地址" type="textarea" class="textareaStyle" />
          <or-upload v-model="form.ppt_zip_path" mode="files" @input="uploadfile" button-text="上传PPT" />
        </a-form-item>
        <a-form-item>
          <a-input v-model="form.video_path" type="textarea" placeholder="视频地址" />
          <or-upload v-model="form.video_path" mode="video" @input="uploadVideo" button-text="上传视频" />
        </a-form-item>
      </a-form>
    </a-modal>
  </or-layout>
</template>

<script>
import AFormItem from "ant-design-vue/es/form/FormItem";
import OrUpload from "@/components/upload";

export default {
  components: { AFormItem, OrUpload },
  data() {
    return {
      data: [],
      pageinfo: { total: 1, current: 1, pageSize: 10 },
      loading: false,
      visible: false,
      gradeList: [],
      myseries: [{ "id": "f167e143ffe7ef25becb814bd29a1790", "name": "易成数学" }, { "id": "f167e143ffe7ef25becb814bd29a1792", "name": "爱华英语" }, { "id": "f167e143ffe7ef25becb814bd29a1793", "name": "思涵语文" }, { "id": "f167e143ffe7ef25becb814bd29a1794", "name": "量变物理" }, { "id": "f167e143ffe7ef25becb814bd29a1795", "name": "有色化学" }],
      semesterList: [],
      searchFrom: {
        keyword: "",
        semester_id: "",
        grade_id: "",
        subject: 1
      },
      form: {
        id: "",
        name: "",
        grade_id: "",
        semester_id: "",
        ppt_zip_path: undefined,
        ppt_path: undefined,
        video_path: undefined,
        subject: "",
        series: "",
      }
    };
  },
  mounted() {
    this.getGradeList();
    this.getSemesterList();
    this.tableSearch();
  },
  methods: {
    getGradeList() {
      this.$axios
        .post("/api/BasicGrade/index")
        .then(res => {
          if (res.code == 200) {
            this.gradeList = res.data.data;
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    getSemesterList() {
      this.$axios
        .post("/api/BasicSemester/index")
        .then(res => {
          if (res.code == 200) {
            this.semesterList = res.data.data;
          }
        })
        .catch(err => {
          console.error(err);
        });

    },
    selectItem(pid) {
      this.form.pid = pid;
    },
    //文件上传
    uploadfile() {
      console.info("上传文件:", this.form.ppt_zip_path);
      console.log("上传文件2:", this.form.ppt_zip_path);
      var dates = this.form.ppt_zip_path;
      var zipW = ".zip";
      var htmlW = "/index.html";
      var newString = dates.replace(zipW, htmlW);

      console.log('替换后的：' + newString);
      this.form.ppt_path = newString;
      // console.log('name:');
    },
    // 视频上传
    uploadVideo() {
      console.info("上传文件:", this.form.video_path);
    },
    changeStatus(data) {
      this.$axios
        .post("/api/BasicCourse/edit", { data })
        .then(res => {
          if (res.code != 200) {
            this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定"
            });
          } else {
            this.getTableList();
          }
        })
        .catch(err => {
          console.error(err);
        });
    },

    onPaginationChange(item) {
      this.pageinfo.current = item.current;
      this.getTableList(this.searchFrom);

    },
    tableSearch() {
      this.pageinfo.current = 1;
      this.getTableList(this.searchFrom);
    },
    getTableList(data) {
      this.$axios
        .post("/api/BasicCourse/index", {
          data, pageinfo: this.pageinfo
        })
        .then(res => {
          if (res.code != 200) {
            this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定"
            });
          } else {
            this.data = res.data.data;
            this.pageinfo = res.data.pageinfo;
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    tableEdit(item) {
      this.form.id = item.id;
      this.form.name = item.name;
      this.form.semester_id = item.semester_id;
      this.form.grade_id = item.grade_id;
      this.form.ppt_zip_path = item.ppt_zip_path;
      this.form.ppt_path = item.ppt_path;
      this.form.video_path = item.video_path;
      this.form.subject = item.subject;
      this.form.series = item.series;
      console.log('this.form.video_path:' + this.form.video_path);
      this.visible = true;
    },

    tableAdd() {
      this.form = {};
      this.visible = true;
    },
    tableDel(data) {
      let _this = this;
      this.$confirm({
        title: "删除权限",
        content: "确认删除当前权限吗?",
        okText: "确认",
        cancelText: "取消",
        onOk: function () {
          _this.$axios
            .post("/api/BasicCourse/del", { data })
            .then(res => {
              if (res.code != 200) {
                _this.$error({
                  title: "错误",
                  content: res.msg,
                  okText: "确定"
                });
              } else {
                _this.searchbtn()
              }
            })
            .catch(err => {
              console.error(err);
            });
        }
      });
    },
    modalSave() {
      let _this = this;
      if (!this.form.grade_id) {
        _this.$error({
          title: "错误",
          content: "年级为必选项",
          okText: "确定"
        });
        return false;
      }
      if (!this.form.semester_id) {
        _this.$error({
          title: "错误",
          content: "学期为必选项",
          okText: "确定"
        });
        return false;
      }
      let url = "/api/BasicCourse/edit";
      if (!this.form.id) {
        url = "/api/BasicCourse/add";
      }
      this.$axios
        .post(url, { data: this.form })
        .then(res => {
          if (res.code != 200) {
            _this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定"
            });
          } else {
            _this.tableSearch();
            _this.visible = false;
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    modalCancel() {
      this.visible = false;
    },

  }
};
</script>
<style>
.active_btn {
  margin-left: 5px;
}

.pptAddress {
  /* display: flex; */
}

.textareaStyle {
  min-height: 200px;
}
</style>